import classNames from 'classnames';
import Image from 'next/image';
import { useProductPageContext } from './hooks/useProductPageContext';
import AddToCartLink from './AddToCartLink';
import ProductPrice from './sections/main/right/product/ProductPrice';
import PrimaryTitleWithBadge from './sections/main/right/product/PrimaryTitleWithBadge';
import { splitProductTitle } from './sections/main/right/product/helpers';
import { generateCarouselImages } from './sections/main/left/image/helpers';

const TopBar = ({ shouldShowTopBar }: { shouldShowTopBar: boolean }) => {
  const {
    selectedOffer,
    selectedWarranty,
    selectedSkuDetails: { title },
    isFetchingSku,
    selectedSku,
    product,
    isOutOfStock,
  } = useProductPageContext();

  // The gallery's first image, so it follows the selected variant.
  const image = generateCarouselImages(selectedSku, product, isOutOfStock)?.[0];

  const { primaryTitle, secondaryTitle, showUnlocked } =
    splitProductTitle(title);

  return (
    <div
      className={classNames(
        'fixed top-0 z-[60] w-full bg-white drop-shadow-md transition-all duration-150 ease-in-out lg:drop-shadow-md',
        {
          'visible opacity-100': shouldShowTopBar,
          'invisible opacity-0': !shouldShowTopBar,
        },
      )}
    >
      <div
        className={classNames(
          'xl:reebelo-container mx-auto px-5 py-5 xl:px-8',
          {
            'opacity-60': isFetchingSku,
          },
        )}
      >
        <div className="flex items-center justify-between gap-2">
          <div className="flex min-w-0 items-center gap-3">
            {image?.url && (
              <Image
                src={image.url}
                alt={title}
                width={44}
                height={44}
                className="h-11 w-11 shrink-0 object-contain"
              />
            )}
            <div className="min-w-0">
              {/* Do not use H1 here */}
              <span className="relative block w-full text-base font-bold leading-5">
                <PrimaryTitleWithBadge
                  primaryTitle={primaryTitle}
                  showUnlocked={showUnlocked}
                />
              </span>
              {secondaryTitle && (
                <div className="mt-1 text-xs font-medium leading-tight">
                  {secondaryTitle}
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center gap-4">
            <ProductPrice alignRight className="text-right" />
            <div className="min-w-[200px] shrink-0">
              <AddToCartLink
                testingId="e2e-pdp-top-bar-add-to-cart"
                id="topBarPurchaseCont"
                offer={selectedOffer}
                selectedWarranty={selectedWarranty}
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
